export interface IBundleOnDevice {
  acquirerBundleStatus: string;
  acquirerEntityUid: string;
  appmarketBundleId: string;
  bundleIcon: string;
  bundleId: string;
  bundleName: string;
  bundleVersionId: string;
  bundleVersionName: string;
  bundleDeploymentStatus: string;
  bundleDeploymentUninstallStatus: string;
  createdBy: string;
  status: string;
  timeCreated: Date;
  timeUpdated: Date;
  updatedBy: string;
}
